// Every GA4 event goes through Google Tag Manager (GTM-KFFR5Q7), whose tags read their parameters at the top
// level of the dataLayer: dataLayer.push({ event: 'cta', cta_name: 'menu' }). gtag('event', name, params) files
// them elsewhere in the GTM data model, which left every GA4 parameter "(not set)" from nuxt-gtag 2 (04/2024).
//
// The dataLayer keeps the last value of a key: each push clears the parameters the tags read, so an event never
// carries the parameter of the previous one. GTM only starts once the visitor accepts the cookies
// (plugins/gtag.client.ts): until then the pushes stay in the page, nothing is sent.

type TrackParams = Record<string, string | number | undefined>

/** dataLayer keys read by the GTM tags (Data Layer Variables). */
const TRACK_KEYS = [
  'cta_name',
  'typeEvent',
  'popupName',
  'loginMethod',
  'signupMethod',
  'searchterm',
  'interaction',
  'target_url',
  'nomcommunaute',
] as const

const dataLayer = (): unknown[] => {
  const w = window as Window & { dataLayer?: unknown[] }
  w.dataLayer = w.dataLayer || []
  return w.dataLayer
}

export const track = (event: string, params: TrackParams = {}) => {
  if (import.meta.server) return

  const cleared = Object.fromEntries(TRACK_KEYS.map((key) => [key, undefined]))
  dataLayer().push({ ...cleared, ...params, event })
}

/** Connected or not, sent with every GA4 event and page view (GA4 dimension "Login Status"). */
export const trackLoginStatus = (connected: boolean) => {
  if (import.meta.server) return

  dataLayer().push({ login_status: connected ? 'connecte' : 'visiteur' })
}
